import { useAuth } from '@/lib/auth'
import { Button } from '@/components/ui/button'
import { LogOut } from 'lucide-react'
import { LiveIndicator } from '@/components/LiveIndicator'

export function Topbar() {
  const whoami = useAuth((s) => s.whoami)
  const logout = useAuth((s) => s.logout)

  return (
    <header className="h-14 shrink-0 border-b border-border px-4 flex items-center justify-between bg-card/30">
      <div className="text-sm text-muted-foreground flex items-center gap-4">
        {whoami ? (
          <span>
            Signed in as <span className="text-foreground">{whoami.name}</span>{' '}
            <span className="ml-1 rounded bg-muted px-1.5 py-0.5 text-xs uppercase tracking-wide">
              {whoami.scope}
            </span>
          </span>
        ) : null}
      </div>
      <div className="flex items-center gap-4">
        <LiveIndicator />
        <Button
          variant="ghost"
          size="sm"
          onClick={() => void logout()}
          aria-label="Sign out"
        >
          <LogOut className="h-4 w-4 mr-2" />
          Sign out
        </Button>
      </div>
    </header>
  )
}
